import { FeatureFlag } from '@ps/web-core-enums';
import { select, useDispatch, useFeature } from '@ps/web-core-store';
import { StarsButton } from '@ps/web-shared-components';
import type React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import ActiveTableIcon from '../../../assets/active-table.svg';

import styles from './ActiveTableButton.module.scss';

const ActiveTableButton: React.FC = () => {
  const { modal } = useDispatch();
  const games = useSelector(select.activeGames.getGames);
  const { idpToken } = useSelector(select.session.get);
  const enableActiveGamesSubscription = useFeature(FeatureFlag.PKRNavigationActiveTableButton);
  const idpSecondaryLoginEnabled = useFeature(FeatureFlag.IdpSecondaryLoginEnabled);
  const openActiveGamesModal = useCallback(
    () =>
      modal.enqueue({
        path: '/poker/active-games',
        locationState: {}
      }),
    [modal]
  );

  if (!enableActiveGamesSubscription || !idpSecondaryLoginEnabled || !idpToken) return null;

  return (
    <div className={styles.wrap}>
      <StarsButton
        className={styles.activeTableButton}
        icon={<ActiveTableIcon />}
        type="button"
        onClick={openActiveGamesModal}
      />
      {!!games.length && <span className={styles.badge}>{games.length}</span>}
    </div>
  );
};

export default ActiveTableButton;
